import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getMicroToken } from './microToken'

const timer = 100 * 1000
    // axios

const service = axios.create({
    baseURL: `${process.env.VUE_APP_MICROSERVICE}/`, // api base_url,
    headers: {
        Accept: 'application/json'
    },
    timeout: timer // time out for request
})
service.defaults.headers['Content-Type'] = 'application/json'

// request
service.interceptors.request.use(
    config => {
        if (!config.notAuthorized) {
            config.headers['Authorization'] = getMicroToken()
        } else {
            delete config.headers['Authorization']
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (response.status !== 200 && response.status !== 201) {
            Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
            });
            return Promise.reject('error');
        } else {
            return response.data;
        }
    },
    error => {
        const config = error.config || {};
        const suppressError = config.suppressError || false;
        const isMonitorRequest = config.url && (config.url.includes('horizon/api/') || config.url.includes('api/bash/'));
        
        console.error("Request failed with status code:", error.request?.status);
        console.error("Error details:", error);

        if (error.request?.status === 401) {
            store.dispatch('MicroFedLogOut').then(() => {
                location.reload();
            });
        } else if (error.request?.status === 422) {
            if (!suppressError) {
                let message = "Authorization data is incorrect";
                Message({
                    message: message,
                    type: 'error',
                    duration: 5 * 1000
                });
            }
        } else if (error.request?.status === 423 || error.request?.status === 500) {
            if (!suppressError) {
                const data = error.response ? error.response.data : null;
                let message = data ? data.message : error.message;
                Message({
                    message: message,
                    type: 'error',
                    duration: 5 * 1000
                });
            }
        } else {
            if (!suppressError && !isMonitorRequest) {
                Message({
                    message: "Unexpected error occurred",
                    type: 'error',
                    duration: 5 * 1000
                });
            }
        }

        return Promise.reject(error);
    }
)

export default service